// Mock data para COPARMEX Manzanillo

export const companyInfo = {
  name: "COPARMEX Manzanillo",
  slogan: "Somos el organismo empresarial que representa al mayor número de empresas en México",
  description: "Somos un sindicato patronal apartidista y de afiliación voluntaria que reúne a empresarios de todos los tamaños y sectores, a quienes representamos en los ámbitos laboral, económico, social y político.",
  address: "Av Elías Zamora 3009-planta alta, Manzanillo, Col.",
  phone: "314 334 2929",
  phone2: "314 333 3670",
  whatsapp: "314 121 7143",
  email: "atencionsocios@coparmexmanzanillo.org",
  schedule: "Lunes - Viernes: 09:00 - 14:00 | 16:00 - 19:00",
  social: {
    twitter: "https://twitter.com/Coparmex_mzo",
    facebook: "https://www.facebook.com/coparmexmzo",
    instagram: "https://www.instagram.com/coparmex_manzanillo/",
    youtube: "https://www.youtube.com/@coparmexmanzanillo"
  }
};

export const stats = [
  { number: "180", label: "Empresas Afiliadas" },
  { number: "1,500", label: "Colaboradores Capacitados" },
  { number: "44", label: "Cursos y Eventos por año" }
];

export const values = [
  "Dignidad de la persona",
  "Liderazgo",
  "Participación",
  "Responsabilidad",
  "Solidaridad",
  "Subsidiariedad",
  "Perseverancia",
  "Trabajo en equipo",
  "Honestidad"
];

export const benefits = [
  {
    title: "Representatividad",
    description: "COPARMEX es una organización que agrupa a más de 36,000 empresas en todo el país, lo que la convierte en una de las organizaciones empresariales más grandes y representativas de México."
  },
  {
    title: "Participación en la vida política",
    description: "COPARMEX es una organización que se involucra activamente en la vida política del país, a través de la promoción de iniciativas y propuestas que buscan mejorar el entorno empresarial y económico de México."
  },
  {
    title: "Compromiso con la ética y responsabilidad social",
    description: "COPARMEX tiene un fuerte compromiso con la ética y la responsabilidad social empresarial, lo que se traduce en la promoción de prácticas empresariales sostenibles y socialmente responsables."
  },
  {
    title: "Promoción del emprendimiento e innovación",
    description: "COPARMEX busca fomentar el emprendimiento y la innovación en México, a través de la creación de programas y proyectos que buscan impulsar el desarrollo económico y empresarial del país."
  }
];

export const commissions = [
  {
    id: 1,
    name: "Atención a Socios",
    president: "Lic. Omar Gibran González Topete",
    description: "Generar la vinculación entre los socios del CEM que permita conocer y apoyar a solucionar las necesidades de estos y encausarlas a las comisiones correspondientes para generar acciones que les aporten valor."
  },
  {
    id: 2,
    name: "Comercio",
    president: "Lic. Adriana Chacón Sánchez",
    description: "Promover la interrelación de los socios de COPARMEX Manzanillo, e incentivar su participación en actividades que aporten al desarrollo, crecimiento y fortalecimiento de sus empresas."
  },
  {
    id: 3,
    name: "Vivienda",
    president: "Lic. Magdalena Montiel Solís",
    description: "Generar conciencia mediante la representación empresarial, buscando coadyuvar esfuerzos con la industria de la vivienda y el desarrollo urbano."
  },
  {
    id: 4,
    name: "Innovación y Desarrollo Empresarial",
    president: "Ing. José Pompeyo Tovar",
    description: "Promover entre los socios las buenas prácticas empresariales, el emprendimiento, la innovación y la inversión."
  },
  {
    id: 5,
    name: "Educación y Talento Humano",
    president: "Lic. Silvia Alejandra Caldera Saldívar",
    description: "Promover la participación entre colaboradores, emprendedores y empresarios en proyectos de mejora del talento humano."
  },
  {
    id: 6,
    name: "Fiscal",
    president: "C.P.C. Marco Antonio Flores Santos",
    description: "Asesorar a los socios y darles a conocer de manera constante temas relevantes mediante actividades que favorezcan el estudio para el cumplimiento en materia Fiscal."
  },
  {
    id: 7,
    name: "Grandes Empresas",
    president: "Ing. Arturo Villaseñor Sánchez",
    description: "Fomentar a que las grandes empresas sean un motor de crecimiento regional, generando relaciones y fortaleciendo a las empresas de diversos tamaños."
  },
  {
    id: 8,
    name: "Laboral",
    president: "Mtro. Uriel Moreno Flores",
    description: "Asesorar a los socios y darles a conocer de manera constante temas relevantes mediante actividades que favorezcan el estudio para el cumplimiento en materia laboral."
  },
  {
    id: 9,
    name: "Responsabilidad Social y Desarrollo Sustentable",
    president: "Dra. Fabiola Polo Melgarejo",
    description: "Contribuir al Desarrollo Sostenible en sus tres dimensiones social, ambiental y económico, en el Puerto de Manzanillo."
  },
  {
    id: 10,
    name: "Puerto y Logística",
    president: "Mtro. Omar Aréchiga de Alba",
    description: "Generar planes y estrategias que permitan facilitar la implementación de acciones enfocadas a generar un desarrollo puerto – ciudad."
  },
  {
    id: 11,
    name: "Turismo",
    president: "Lic. Héctor Sandoval Fierros",
    description: "Representar en las diferentes asociaciones y dependencias gubernamentales los intereses turísticos."
  },
  {
    id: 12,
    name: "Empresarios Jóvenes",
    president: "Lic. Gerasimos Digenis Kremastoulis Victoria",
    description: "Impulsar el desarrollo de los jóvenes en el Puerto de Manzanillo como futuros empresarios, líderes y ciudadanos."
  },
  {
    id: 13,
    name: "Anticorrupción y Seguridad",
    president: "Lic. Alejandro Gaitán Sánchez",
    description: "Promover una cultura de integridad dentro de las empresas generando conciencia que contribuya a reducir la corrupción."
  }
];

export const directoryCategories = [
  {
    category: "Aduanales",
    companies: [
      { name: "Agencia Aduanal Hugo Herrera", address: "Carretera Manzanillo-Minatitlán Km 1.6, Tapeixtles", phone: "314 331 1600" },
      { name: "Alianza Estratégica Portuaria S.A. de C.V.", address: "Carretera Manzanillo-Minatitlán Km 1.0, No.52", phone: "314 331 0404" },
      { name: "C&E Agentes Aduanales S.A. de C.V.", address: "Blvd. Miguel De La Madrid Hurtado No.426", phone: "314 335 4215" },
      { name: "GCB Logística Aduanal S.C.", address: "Manuel Bonilla Valle No.484, Col. Las Brisas", phone: "314 333 6564" }
    ]
  },
  {
    category: "Logísticos",
    companies: [
      { name: "Alta Stockman", address: "Av. Lázaro Cárdenas #1248, colonia Morelos", phone: "314 331 1140" },
      { name: "CIMA Group", address: "Carretera Manzanillo-Minatitlán Km 4.5", phone: "314 336 7244" },
      { name: "Grupo Galván", address: "Av. Dos Oriente No.13, Parque Industrial Fondeport", phone: "314 332 2565" },
      { name: "Impala Terminals México", address: "Carretera Manzanillo-Minatitlán Km 1.5", phone: "314 331 5500" }
    ]
  },
  {
    category: "Hotelería y Turismo",
    companies: [
      { name: "Holiday Inn Express Manzanillo", address: "Blvd. Miguel De La Madrid No.424", phone: "314 331 2330" },
      { name: "Hotel Gran Isla Navidad", address: "Circuito De Los Marinos S/N, Isla Navidad", phone: "314 331 0500" },
      { name: "Corporativo Marbella", address: "Blvd. Miguel De La Madrid No.1077", phone: "314 333 1102" },
      { name: "Hectours", address: "Blvd. Miguel de la Madrid No.3147, Playa Azul", phone: "314 333 1707" }
    ]
  },
  {
    category: "Terminal Portuaria",
    companies: [
      { name: "Contecon Manzanillo S.A. de C.V.", address: "Blvd. Miguel De La Madrid Hurtado No.1519", phone: "314 980 0553" },
      { name: "SSA México", address: "Blvd. Miguel De La Madrid No.855", phone: "314 331 1000" },
      { name: "TAP La Junta S.A. de C.V.", address: "Av. Lázaro Cárdenas #1248, Col. Morelos", phone: "314 331 2570" }
    ]
  },
  {
    category: "Financieros",
    companies: [
      { name: "Banco Monex S.A.", address: "Blvd. Miguel De La Madrid Hurtado No.256", phone: "314 190 0904" },
      { name: "Caja Popular Manzanillo", address: "Av. México No. 386 Col. Centro", phone: "314 332 1084" },
      { name: "Intercam Banco", address: "Blvd Miguel de la Madrid No. 874", phone: "314 119 8770" }
    ]
  }
];

export const historyTimeline = [
  {
    year: "1929",
    title: "Fundación de COPARMEX",
    description: "La Confederación Patronal de la República Mexicana (COPARMEX) fue fundada como un sindicato patronal para representar los intereses de los empresarios mexicanos."
  },
  {
    year: "1970s",
    title: "Expansión Regional",
    description: "COPARMEX comienza su expansión hacia diferentes estados de la República, estableciendo centros empresariales en ciudades estratégicas."
  },
  {
    year: "1980s",
    title: "Establecimiento en Manzanillo",
    description: "Se establece el Centro Empresarial de Manzanillo para atender las necesidades del creciente sector empresarial portuario y comercial de la región."
  },
  {
    year: "2000s",
    title: "Consolidación",
    description: "COPARMEX Manzanillo se consolida como el principal organismo empresarial de la región, agrupando empresas de diversos sectores."
  },
  {
    year: "Actualidad",
    title: "Liderazgo Regional",
    description: "Con más de 180 empresas afiliadas, COPARMEX Manzanillo continúa siendo líder en la representación empresarial del puerto más importante del Pacífico mexicano."
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "2da Asamblea Ordinaria 2024",
    excerpt: "Se llevó a cabo la segunda asamblea ordinaria del año donde se presentaron los avances y logros del centro empresarial.",
    date: "2024-11-29",
    category: "Atención a Socios",
    image: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800"
  },
  {
    id: 2,
    title: "Convocatoria - Asamblea Ordinaria Electiva 2024",
    excerpt: "Se convoca a todos los socios a participar en la asamblea ordinaria electiva para la renovación de la mesa directiva.",
    date: "2024-12-03",
    category: "Atención a Socios",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800"
  },
  {
    id: 3,
    title: "Foro de Innovación Empresarial",
    excerpt: "COPARMEX Manzanillo organiza el primer foro de innovación empresarial con participación de expertos nacionales.",
    date: "2024-10-15",
    category: "Innovación",
    image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800"
  },
  {
    id: 4,
    title: "Capacitación en Materia Fiscal",
    excerpt: "La comisión fiscal ofrece capacitación gratuita para socios sobre las nuevas disposiciones fiscales.",
    date: "2024-09-20",
    category: "Fiscal",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "La importancia de la responsabilidad social empresarial",
    excerpt: "Descubre cómo las empresas pueden contribuir al desarrollo sostenible de sus comunidades mientras fortalecen su imagen corporativa.",
    date: "2024-11-15",
    author: "Comisión de Responsabilidad Social",
    category: "Responsabilidad Social",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800",
    content: "La responsabilidad social empresarial (RSE) se ha convertido en un pilar fundamental para las organizaciones modernas. No se trata solo de cumplir con las obligaciones legales, sino de ir más allá y contribuir activamente al bienestar de la sociedad."
  },
  {
    id: 2,
    title: "Tendencias en logística portuaria 2024",
    excerpt: "El Puerto de Manzanillo continúa siendo líder en comercio exterior. Conoce las tendencias que están transformando la industria.",
    date: "2024-10-28",
    author: "Comisión de Puerto y Logística",
    category: "Logística",
    image: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=800",
    content: "El sector logístico portuario está experimentando una transformación sin precedentes. La digitalización, la automatización y la sostenibilidad son las principales tendencias que están redefiniendo la industria."
  },
  {
    id: 3,
    title: "Emprendimiento juvenil: El futuro empresarial de Manzanillo",
    excerpt: "Los jóvenes empresarios están transformando el panorama económico de la región con ideas innovadoras y visión de futuro.",
    date: "2024-10-10",
    author: "Comisión de Empresarios Jóvenes",
    category: "Emprendimiento",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800",
    content: "El emprendimiento juvenil está cobrando cada vez más relevancia en Manzanillo. Los jóvenes empresarios están demostrando que la edad no es un impedimento para liderar proyectos exitosos."
  },
  {
    id: 4,
    title: "Estrategias fiscales para PyMEs en 2024",
    excerpt: "Optimiza la carga fiscal de tu empresa con estas estrategias legales y efectivas recomendadas por expertos.",
    date: "2024-09-25",
    author: "Comisión Fiscal",
    category: "Fiscal",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800",
    content: "La planeación fiscal es fundamental para la salud financiera de cualquier empresa. Conocer las opciones legales disponibles puede significar un ahorro significativo en el pago de impuestos."
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Desayuno Empresarial",
    date: "2025-01-15",
    time: "08:00 - 10:00",
    location: "Hotel Holiday Inn Express",
    description: "Networking y presentación de nuevos socios"
  },
  {
    id: 2,
    title: "Taller de Liderazgo",
    date: "2025-01-22",
    time: "16:00 - 19:00",
    location: "Oficinas COPARMEX",
    description: "Desarrollo de habilidades de liderazgo empresarial"
  },
  {
    id: 3,
    title: "Foro PyMEs 2025",
    date: "2025-02-05",
    time: "09:00 - 17:00",
    location: "Centro de Convenciones",
    description: "Encuentro anual de pequeñas y medianas empresas"
  }
];
